import React, { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaShoppingBag, FaTags, FaGift, FaUsers, FaStar, FaChartBar } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { IoSettings } from "react-icons/io5";

const sidebarItems = [
  { icon: <FaHome aria-label="Home" />, label: "Home", path: "/admin" },
  { icon: <FaShoppingBag aria-label="Orders" />, label: "Orders", path: "/admin/orders" },
  { icon: <FaTags aria-label="Brands" />, label: "Brands", path: "/admin/brands" },
  { icon: <MdCategory aria-label="Categories" />, label: "Categories", path: "/admin/categories" },
  { icon: <AiFillProduct aria-label="Products" />, label: "Products", path: "/admin/products" },
  { icon: <FaGift aria-label="Offers" />, label: "Offers", path: "/admin/offers" },
  { icon: <FaUsers aria-label="Users" />, label: "Users", path: "/admin/users" },
  { icon: <FaStar aria-label="Featured Products" />, label: "Featured Products", path: "/admin/featured-products" },
  { icon: <FaChartBar aria-label="Reports" />, label: "Reports", path: "/admin/admin-report" },
  { icon: <IoSettings aria-label="Settings" />, label: "Settings", path: "/admin/settings" },
];

const AdminSidebar = memo(({ isOpen, onItemClick }) => {
  const location = useLocation();
  const handleItemClick = () => {
    if (onItemClick) {
      onItemClick();
    }
  };

  return (
    <div className={`admin-sidebar ${isOpen ? 'mobile-open' : ''}`}>
      <ul>
        {sidebarItems.map((item, index) => {
          const isHome = item.path === "/admin";
          const isActive = isHome
            ? location.pathname === "/admin"
            : location.pathname === item.path || location.pathname.startsWith(item.path + '/');
          return (
            <li key={index} className={isActive ? 'active-menu' : ''}>
              <Link to={item.path} onClick={handleItemClick}>
                {item.icon}
                <span>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
});

export default AdminSidebar;
